<template>
  <div class="goods_list">
    <!--供应商公告列表头部-->
    <div class="goods_list_top">
      <!--<a href="http://59.42.10.82:8005/upload/GoodsMainImg/1001181106170511815.jpg" download="test.jpg">下载</a>-->
      <div><input type="text" v-model.trim="idOrName" title="货号/品名" placeholder="货号/品名"></div>
      <div>
        <el-select v-model="selectTimeType" placeholder="请选择">
          <el-option
            v-for="item in timeTypeList"
            :key="item.id"
            :label="item.text"
            :value="item.id">
          </el-option>
        </el-select>
      </div>
      <div>
        <el-date-picker
          v-model.trim="startTime"
          type="date"
          placeholder="开始时间"
          format="yyyy/MM/dd">
        </el-date-picker>
      </div>
      <span class="fl mt5">至</span>
      <div style="margin-left: 1%">
        <el-date-picker
          v-model.trim="endTime"
          type="date"
          placeholder="结束时间"
          format="yyyy/MM/dd">
        </el-date-picker>
      </div>
      <div>
        <el-select v-model="selectBrandType" placeholder="请选择">
          <el-option
            v-for="item in brandTypeList"
            :key="item.id"
            :label="item.text"
            :value="item.id">
          </el-option>
        </el-select>
      </div>
      <div>
        <el-select v-model="selectCodeSegmentType" placeholder="请选择">
          <el-option
            v-for="item in codeSegmentTypeList"
            :key="item.id"
            :label="item.text"
            :value="item.id">
          </el-option>
        </el-select>
      </div>
      <div>
        <el-select v-model="selectClassificationType" placeholder="分类">
          <el-option
            v-for="item in codeClassificationList"
            :key="item.id"
            :label="item.text"
            :value="item.id">
          </el-option>
        </el-select>
      </div>
      <div>
        <div class="inb">
          <input type="checkbox" id="pic_zip" v-model="isCompress">
          <label for="pic_zip">显示有图片压缩包的货品信息</label>
        </div>
        <button class="btn_normal w116 ml10" @click="queryData()">查询</button>
      </div>
    </div>

    <!--供应商公告列表信息-->
    <div class="goods_list_msg">
      <!--表格-->
      <table class="table">
        <thead>
        <tr>
          <th>货号</th>
          <th>品名</th>
          <th>品牌</th>
          <th>码段</th>
          <th>分类</th>
          <th>性别</th>
          <th>上市季节</th>
          <th>创建时间</th>
          <th>零售价</th>
          <th>操作</th>
        </tr>
        </thead>
        <tbody v-if="list.length">
        <tr v-for="(item, index) in list" :key="index">
          <td>{{item.GoodsId}}</td>
          <td>{{item.GoodsName}}</td>
          <td>{{item.BrandName}}</td>
          <td>{{item.SGName}}</td>
          <td>{{item.ClassName}}</td>
          <td>{{item.gender}}</td>
          <td>{{item.MarketSeasoin}}</td>
          <td>{{item.CreateTime | time}}</td>
          <td>{{item.MarketPrice}}</td>
          <td>
            <a title="查看详情" @click="ctrlBtn('goodDetail', item)">查看详情</a>
            <!--<a title="下载图片" @click="downMainImg(item.GoodsId)">下载图片</a>-->
            <!--<a title="下载图片" :href="'http://59.42.10.82:8008//upload/GoodsMainImg/1007181101174220775.jpg'">下载图片</a>-->
          </td>
        </tr>
        </tbody>
        <tbody v-if="!list.length">
        <tr>
          <td colspan="10">暂时没有相关信息</td>
        </tr>
        </tbody>
      </table>

      <!--分页-->
      <div v-if="list.length" class="text_right mt20">
        <el-pagination
          background
          :prev-text="'上一页'"
          :next-text="'下一页'"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[5, 10, 15, 20]"
          :page-size="pageSize"
          layout="total, prev, pager, next, sizes, jumper"
          :total="total">
        </el-pagination>
      </div>
    </div>

    <!--弹出框-->
    <goods-list-embed-msg v-if="isShow" :title="dialogTitle" :goodMsg="goodMsg"
                          :showType="dialogShowType" @cancelbtn="getSelectDialogEmbed"></goods-list-embed-msg>

    <!--提示框-->
    <msg-dialog v-if="isMsg"
                :txt="txtMsg"
                :is-suc="isSuc"
                @closebtn="closeTipsDialog"></msg-dialog>

    <!--加载框-->
    <loading-dialog v-if="isLoading" :type="'NOP'"></loading-dialog>
  </div>
</template>

<script type="es6">
  import GoodsListEmbedMsg from './goods-list-embed-msg';
  import MsgDialog from '../../public-component/msg-dialog';
  import LoadingDialog from '../../public-component/loading-dialog';

  export default {
    name: 'goods-list',
    components: {GoodsListEmbedMsg, LoadingDialog, MsgDialog},
    data() {
      return {
        list: [], // 货品列表信息
        idOrName: '', // 货号/品名
        timeTypeList: [
          {id: 0, text: '查询时间'},
          {id: 1, text: '上市时间'},
          {id: 2, text: '创建时间'}
        ], // 查询时间下拉列表
        selectTimeType: 0, // 选择到的查询时间类型
        startTime: '', // 开始时间
        endTime: '', // 结束时间
        brandTypeList: [
          {id: '', text: '所有品牌'},
          {id: '耐克', text: '耐克'},
          {id: '李宁', text: '李宁'}
        ], // 查询品牌下拉列表
        selectBrandType: '', // 选择到的查询品牌类型
        codeSegmentTypeList: [
          {id: '', text: '所有码段'},
          {id: '男鞋', text: '男鞋'},
          {id: '女鞋', text: '女鞋'}
        ], // 查询码段下拉列表
        selectCodeSegmentType: '', // 选择到的查询码段类型
        codeClassificationList: [], // 查询分类下拉列表
        selectClassificationType: '', // 选择到的查询分类类型
        isCompress: false, // 是否有图片压缩包的货品信息
        goodMsg: '', // 货品详情
        isLoading: false, // 是否显示加载框
        isMsg: false, // 信息框显示
        isSuc: false, // 是否成功
        txtMsg: '', // 信息框内容
        isShow: false, // 提示框显示
        dialogTitle: null, // 弹出框头部名
        dialogShowType: null, // 弹出框类型
        currentPage: 1, // 当前页数
        pageSize: 10, // 当前显示几条数据
        total: 10 // 总条数
      }
    },
    methods: {
      // 加载品牌下拉数据
      getAllBrandsList() {
        this.$axios.get(this.Global.getAllBrandsList).then((res) => {
          if (!res.data.errorMsg.length) {
            this.brandTypeList = res.data.resData;
            this.brandTypeList.splice(0, 0, {id: '', text: '所有品牌'});
            this.selectBrandType = '';
          } else {
            this.brandTypeList = [];
          }
        });
      },

      // 加载码段下拉数据
      getAllSizeGroupList() {
        this.$axios.get(this.Global.getAllSizeGroupList).then((res) => {
          if (!res.data.errorMsg.length) {
            this.codeSegmentTypeList = res.data.resData;
            this.codeSegmentTypeList.splice(0, 0, {id: '', text: '所有码段'});
            this.selectCodeSegmentType = '';
          } else {
            this.codeSegmentTypeList = [];
          }
        });
      },

      // 加载分类下拉数据
      getAllClassList() {
        this.$axios.get(this.Global.getAllClassList).then((res) => {
          if (!res.data.errorMsg.length) {
            this.codeClassificationList = res.data.resData;
            this.codeClassificationList.splice(0, 0, {id: '', text: '所有分类'});
            this.selectClassificationType = '';
          } else {
            this.codeClassificationList = [];
            this.selectClassificationType = res.data.errorMsg;
          }
        });
      },

      // 根据货号/品名 + 查询时间类型 + 开始时间 + 结束时间 + 品牌类型 + 码段类型 + 分类 + 是否有图片压缩包的货品信息
      queryData() {
        if (this.startTime && !this.endTime) {
          this.isMsg = true;
          this.isSuc = false;
          this.txtMsg = '请输入结束时间';
        } else if (!this.startTime && this.endTime) {
          this.isMsg = true;
          this.isSuc = false;
          this.txtMsg = '请输入开始时间';
        } else if (this.startTime > this.endTime) {
          this.isMsg = true;
          this.isSuc = false;
          this.txtMsg = '开始时间不能大于结束时间';
        } else {
          this.currentPage = 1;
          this.loadGoodsPageList();
        }
      },

      // 货品列表分页数据
      loadGoodsPageList() {
        this.isLoading = true;
        this.list = [];
        const params = {
          IdorName: this.idOrName, // 货号或名称查询
          TimeType: this.selectTimeType, // 查询时间类型 上市时间或创建时间 0未选择 1上市时间 2创建时间
          BeginCreateTime: this.Global.timeFormatStart(this.startTime), // 开始时间
          EndCreateTime: this.Global.timeFormatEnd(this.endTime), // 结束时间
          ClassId: this.selectClassificationType,
          BrandId: this.selectBrandType,
          SgName: this.selectCodeSegmentType,
          ShowZip: this.isCompress,
          pageIndex: this.currentPage,
          pageSize: this.pageSize
        };
        this.$axios.post(this.Global.loadGoodsPageList, params).then((res) => {
          let timer;
          const self = this;
          timer = setTimeout(function () {
            clearTimeout(timer);
            self.isLoading = false;
            if (res.data) {
              if (!res.data.errorMsg.length) {
                self.list = res.data.resData.DataList;
                self.total = res.data.resData.TotalCounts;
              } else {
                self.list = [];
                self.isMsg = true;
                self.isSuc = false;
                self.txtMsg = res.data.errorMsg;
              }
            }
          }, 500);
          this.list = res.data.resData.DataList;
          this.total = res.data.resData.TotalCounts;
        });
      },

      // 操作按钮
      ctrlBtn(type, goodMsg) {
        this.isShow = true;
        this.dialogShowType = type;
        this.goodMsg = goodMsg;
        this.dialogTitle = '货品详情';
      },

      // 接收弹出框传送的数据
      getSelectDialogEmbed(e) {
        this.isShow = e.isShow;
      },

      // 关闭提示框
      closeTipsDialog(e) {
        this.isMsg = e;
      },

      // 分页——当前页面显示条数改变
      handleSizeChange(val) {
        this.pageSize = val;
        this.loadGoodsPageList();
      },

      // 分页——当前页改变
      handleCurrentChange(val) {
        this.currentPage = val;
        this.loadGoodsPageList();
      }
    },
    created() {
      this.getAllBrandsList();
      this.getAllSizeGroupList();
      this.getAllClassList();
      this.loadGoodsPageList();
    },
    activated() { // 只有keep-alive激活才会被使用
      if (sessionStorage.getItem('isRefresh') === 'true') { // 从左边的菜单进去刷新页面
        sessionStorage.setItem('isRefresh', 'false');
        this.idOrName = '';
        this.selectTimeType = 0;
        this.startTime = '';
        this.endTime = '';
        this.selectBrandType = '';
        this.selectCodeSegmentType = '';
        this.selectClassificationType = '';
        this.isCompress = false;
        this.isShow = false;
        this.currentPage = 1;
        this.pageSize = 10;
        this.total = 0;
        this.loadGoodsPageList();
      }
    },
    beforeRouteLeave(to, from, next) {
      to.meta.keepAlive = true;
      next();
    }
  }
</script>

<style lang="scss" scoped>
  @import "../../../assets/css/home-view";

  .goods_list {
    .goods_list_top {
      height: 82px;

      & > div {
        float: left;
        width: 12.5%;
        max-width: 12.5%;

        &:first-child {
          margin-left: 2%;
        }

        &:last-child {
          display: block;
          margin-top: 10px;
          text-align: right;
          max-width: calc(96.5% + 14px);
          width: calc(96.5% + 14px);
        }
      }

      .el-date-editor.el-input, .el-date-editor.el-input__inner {
        width: 100% !important;
      }
    }

    .goods_list_msg {
      height: calc(100% - 142px);
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/home/goods-management/goods-list.vue